import { LINE_ITEM_TYPE_ID, PRODUCT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { isPricingModelTiered } from 'customer-data-objects/product/Pricing';
import { isMultiCurrencyPrice } from './identifiers';
export const isTieredPricingProperty = (objectTypeId, property, pricingModel) => {
  const subjectIsProductOrLineItem = objectTypeId === PRODUCT_TYPE_ID || objectTypeId === LINE_ITEM_TYPE_ID;
  if (!subjectIsProductOrLineItem) {
    return false;
  }
  const isTieredPricingModel = isPricingModelTiered(pricingModel);
  const isPriceProperty = isMultiCurrencyPrice(property) || property.name === 'price';
  return isTieredPricingModel && isPriceProperty;
};